var _path, _path2, _path3, _path4, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginiconhuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.3 25.7",
    enableBackground: "new 0 0 31.3 25.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M25.2,22.8l-0.7-3.7c-0.2-0.8-0.6-1.6-1.3-2.1 c-0.4-0.3-0.8-0.6-1.2-0.7l-3.2-0.9c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.3-0.3-0.5l-0.1-1.3c0.9-0.7,1.6-1.7,1.9-3 c0.6-0.1,1-0.7,1-1.5c0-0.7-0.4-1.3-0.9-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M11,7.6c-0.5,0.1-0.9,0.7-0.9,1.5 c0,0.8,0.4,1.4,1,1.5c0.3,1.2,1,2.3,1.9,3l-0.1,1.3c0,0.2-0.1,0.4-0.3,0.5c-0.1,0-0.1,0.1-0.2,0.1l-3.2,0.9C8.8,16.4,8.4,16.6,8,17 c-0.7,0.5-1.1,1.3-1.3,2.1L6,22.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M20.1,7.6c0,0,0.3-5.3-4.5-5.3 c-4.8,0-4.5,5.3-4.5,5.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M11.4,5.3c0.2-0.4,0.5-0.7,0.9-0.8 c0.6-0.2,1.4,0,2,0.2c0.9,0.4,1.7,0.9,2.7,1c1,0.1,1.8,0,2.7-0.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 12.6,
    y1: 15.3,
    x2: 15.6,
    y2: 18.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 18.5,
    y1: 15.3,
    x2: 15.6,
    y2: 18.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 15.6,
    y1: 18.3,
    x2: 15.6,
    y2: 20.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginiconhuman);
export default __webpack_public_path__ + "static/media/login icon  human.c9059cd666f9e00968c79dbe54cd2c39.svg";
export { ForwardRef as ReactComponent };